import appConstants from '../../../appConstants';
import CustomCheckBoxCellRenderer from './CustomCheckBoxCellRenderer';

const checkboxCellClassRules = {
  disabledByField: (fieldPath, disabledClassName = 'disabledCheckbox', disabledValue = true) => ({
    [disabledClassName]: (params) => {
      const fieldValue = params.data[fieldPath];
      return fieldValue === disabledValue;
    }
  })
};

export const createCustomCheckboxColumn = (
  disabledField,
  disabledClassName = 'disabledCheckbox'
) => ({
  headerName: '',
  checkboxSelection: false, // Disable default checkbox
  headerCheckboxSelection: true,
  headerClass: 'checkBoxHeader',
  minWidth: appConstants.columnWidth.W_62,
  maxWidth: appConstants.columnWidth.W_62,
  isInvisibleInShowHide: true,
  cellRenderer: CustomCheckBoxCellRenderer,
  cellRendererParams: {
    disabledField: disabledField
  },
  cellClass: "gridCell-centerAlign",
  cellClassRules: {
    ...checkboxCellClassRules.disabledByField(disabledField, disabledClassName)
  }
});
